import React from "react";
import { STATUS } from "../../enums.js";

/** @typedef {import('../../transformers/CfcTournamentTransformer.js').CfcTournamentObjForApi } CfcTournamentObjForApi */

/**
 * @typedef {object} CfcTournamentParams
 * @property {CfcTournamentObjForApi} cfcTournament - Détails de la compétition
 * @property {('small'|'full')} mode - Mode d'affichage de la compétition
 */

/**
 * @param {CfcTournamentParams} props
 */
export default function CfcTournament({ cfcTournament, mode = "full" }) {
  const style = {
    backgroundImage: `url(${cfcTournament.logoUrl})`
  };

  const renderFullMode = () => {
    return (
      <div className="card">
        <div className="card__badges-top-left">
          <span className="badge" style={{ color: cfcTournament.sport_type_color }}>
            {cfcTournament.sport_type}
          </span>
        </div>

        {cfcTournament.status === STATUS.LIVE && (
          <div className="card__badges-top-right">
            <span className="badge badge--live">
              <i className="material-icons">fiber_manual_record</i>En cours
            </span>
          </div>
        )}

        {cfcTournament.cashPrice && (
          <div className="card__badges-bottom-right">
            <span className="badge badge--cash-price">
              <i className="material-icons">attach_money</i>
            </span>
          </div>
        )}

        <a href={cfcTournament.status === STATUS.LIVE ? cfcTournament.leaderboardUrl : cfcTournament.registrationLink}>
          <div className="card__image--background card__imahe-without-header" style={style}></div>
        </a>

        <main className="card__description card__description--no-height">
          <h4 className="title title--h5 title--text-overflow">{cfcTournament.name}</h4>
          <p className="paragraph paragraph--no-margin paragraph--bold-600" style={{ color: cfcTournament.sport_type_color }}>
            {cfcTournament.dateStr}
          </p>
          <p className="paragraph paragraph--grey-700 paragraph--no-margin">{cfcTournament.address}</p>
        </main>
      </div>
    );
  };

  const renderSmallMode = () => {
    return (
      <div className="mediacard">
        <a href={cfcTournament.status === STATUS.LIVE ? cfcTournament.leaderboardUrl : cfcTournament.registrationLink}>
          <div className="mediacard__image" style={style}></div>
        </a>

        <main className="mediacard__content">
          <div className="mediacard__content--flexline">
            <div className="mediacard__content-column">
              <a className="mediacard__link" href={cfcTournament.status === STATUS.LIVE ? cfcTournament.leaderboardUrl : cfcTournament.registrationLink}>
                <h4 className="mediacard__title">{cfcTournament.name}</h4>
              </a>
              <p className="mediacard__paragraph">{cfcTournament.address}</p>
            </div>
            <div className="mediacard__content-column">
              {cfcTournament.status === STATUS.LIVE && (
                <span className="badge badge--live">
                  <i className="material-icons">fiber_manual_record</i>En cours
                </span>
              )}
            </div>
          </div>
        </main>
      </div>
    );
  };

  return mode === "full" ? renderFullMode() : renderSmallMode();
}
